import React from 'react';
import clsx from 'clsx';
import SpinnerIcon from '../../assets/icons/spinner-icon.svg?react';

interface SaveAsDraftProps {
  handleSaveAsDraft?: () => void;
  otherClasses?: string;
  isDisabled?: boolean;
  disbaleButtons?: boolean;
}

const SaveAsDraft: React.FC<SaveAsDraftProps> = ({
  otherClasses,
  handleSaveAsDraft,
  isDisabled = false,
  disbaleButtons = false,
}) => {
  const baseClasses = clsx(
    otherClasses,
    'select-none font-inter-variable text-brand-byzantine -tracking-button text-lg leading-5 font-bold lg:text-xl justify-center lg:justify-start lg:leading-6 border-y border-gray-300 xl:border-none py-4 mt-4 flex items-center gap-2 ' +
      (isDisabled ? 'text-gray-400 cursor-block' : 'cursor-pointer'),
  );

  return (
    <button
      type="button"
      onClick={isDisabled ? undefined : handleSaveAsDraft}
      className={baseClasses}
    >
      Save as Draft{' '}
      {disbaleButtons && (
        <SpinnerIcon className="animate-spin [&>rect]:fill-current" />
      )}
    </button>
  );
};

export default React.memo(SaveAsDraft);
